import { ConfigService, SystemUrlService } from "@xo/client-common";

export class Type2LongStringUrlService extends SystemUrlService {
    constructor(system: string, configService: ConfigService) {
        super(system, "SpecApp", "Type2LongString", configService);
    }
}
